import swal from "sweetalert";
// import "react-toastify/dist/ReactToastify.css";
// toast.configure();

export const alert = (title, data, type) => {
  return swal(title, data, type);
};

export const warning = () => {
  return swal({
    title: "Are You Sure!",
    icon: "warning",
    dangerMode: true,
    buttons: true,
  });
};

